import { render, staticRenderFns } from "./EditPersonCourseDialog.vue?vue&type=template&id=e9b24a12&scoped=true&"
import script from "./EditPersonCourseDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonCourseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b24a12",
  null
  
)

export default component.exports